module.exports = __webpack_public_path__ + "static/img/employee_woman.7d7c5b02.svg";